/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Button_Back_To_ReviewInputs */



/**
* | output |
* | --- |
* | "Back to Review" |
*
* @param {Spaces_Wizard_Button_Back_To_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_button_back_to_review = /** @type {((inputs?: Spaces_Wizard_Button_Back_To_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Button_Back_To_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zur Übersicht")
	return /** @type {LocalizedString} */ ("Back to Review")
});